import React, { useState } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableCell,
  Tooltip,
  IconButton,
  Divider,
  Stack,
} from "@mui/material";
import { TENANTS_TABLE_HEADERS } from "../../constant/TableHeaders";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useNavigate } from "react-router-dom";
import {
  StyledTableBody,
  TableBodyRow,
  TableHeaderRow,
} from "../../styles/TableStyles";
import DeleteTenantDialog from "./DeleteTenantDialog";
import ViewTenantDialog from "./ViewTenantDialog";

const TenantTable = ({ rows }) => {
  const navigate = useNavigate();
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [selectedTenantId, setSelectedTenantId] = useState(null);

  const handleViewClick = (property) => {
    setSelectedTenant(property);
    setOpenViewDialog(true);
  };

  const handleViewDialogClose = () => {
    setOpenViewDialog(false);
    setSelectedTenant(null);
  };

  const handleEdit = (id) => {
    navigate(`/tenant/${id}`, { state: { id: id } });
  };

  const handleDeleteClick = (id) => {
    setSelectedTenantId(id);
    setOpenDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setOpenDeleteDialog(false);
    setSelectedTenantId(null);
  };

  const handleDeleteSuccess = () => {
    setTimeout(() => window.location.reload(), 1000);
  };

  return (
    <>
      <TableContainer>
        <Table sx={{ minWidth: 500 }}>
          <TableHead>
            <TableHeaderRow>
              {TENANTS_TABLE_HEADERS.map((item, index) => (
                <TableCell
                  key={index}
                  align={item.alignItemTo}
                  sx={{ width: item.width }}
                >
                  {item.title}
                </TableCell>
              ))}
            </TableHeaderRow>
          </TableHead>

          <StyledTableBody>
            {rows.map((row) => (
              <TableBodyRow
                key={row.id}
                hover
                sx={{
                  "&:hover": {
                    backgroundColor: "#f9f9f9",
                  },
                }}
              >
                <TableCell sx={{ width: 400, alignItemTo: "left" }}>
                  {`${row.tenant_first_name} ${row.tenant_last_name}`}
                </TableCell>
                <TableCell sx={{ width: 400, alignItemTo: "left" }}>
                  {row.tenant_contact}
                </TableCell>
                <TableCell sx={{ width: 200, alignItemTo: "left" }}>
                  {row.entry_date}
                </TableCell>
                <TableCell
                  sx={{ width: 600, alignItemTo: "left" }}
                >{`${row.property_name} - ${row.building_name}`}</TableCell>
                <TableCell sx={{ width: 250, alignItemTo: "left" }}>
                  {row.total_rent_amount}
                </TableCell>

                <TableCell sx={{ width: 150, alignItemTo: "left" }}>
                  <Stack
                    direction="row"
                    spacing={1}
                    divider={<Divider orientation="vertical" flexItem />}
                  >
                    <Tooltip title="View" arrow>
                      <IconButton
                        onClick={() => handleViewClick(row)}
                        size="small"
                      >
                        <VisibilityOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit" arrow>
                      <IconButton
                        onClick={() => handleEdit(row.id)}
                        size="small"
                      >
                        <EditOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete" arrow>
                      <IconButton
                        onClick={() => handleDeleteClick(row.id)}
                        size="small"
                      >
                        <DeleteOutlineOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </TableCell>
              </TableBodyRow>
            ))}
          </StyledTableBody>
        </Table>
      </TableContainer>

      <ViewTenantDialog
        open={openViewDialog}
        onClose={handleViewDialogClose}
        tenant={selectedTenant}
      />

      <DeleteTenantDialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        tenantId={selectedTenantId}
        onSuccess={handleDeleteSuccess}
      />
    </>
  );
};

export default TenantTable;
